import { createClient } from '@supabase/supabase-js';


// Initialize database client
const supabaseUrl = 'https://knvvdlqlzmcyeaszdshe.databasepad.com';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImI0OGZmNzcyLWZkNWItNDI4OC1iNTM2LTg2NDNiYmI1MmNiZSJ9.eyJwcm9qZWN0SWQiOiJrbnZ2ZGxxbHptY3llYXN6ZHNoZSIsInJvbGUiOiJhbm9uIiwiaWF0IjoxNzg4OTA5ODI0LCJleHAiOjIxMDQyNjk4MjQsImlzcyI6ImZhbW91cy5kYXRhYmFzZXBhZCIsImF1ZCI6ImZhbW91cy5jbGllbnRzIn0.k0WK5bcZKY7Ogg5RMyBv0lNQYe4IzvcMtvPQnCff27Y';
const supabase = createClient(supabaseUrl, supabaseKey);


export { supabase };